export const CancelIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1693_252)">
                <path d="M11.9998 0.675049C5.7373 0.675049 0.674805 5.73755 0.674805 12C0.674805 18.2625 5.7373 23.3625 11.9998 23.3625C18.2623 23.3625 23.3623 18.2625 23.3623 12C23.3623 5.73755 18.2623 0.675049 11.9998 0.675049ZM11.9998 21.675C6.67481 21.675 2.3623 17.325 2.3623 12C2.3623 6.67505 6.67481 2.36255 11.9998 2.36255C17.3248 2.36255 21.6748 6.71255 21.6748 12.0375C21.6748 17.325 17.3248 21.675 11.9998 21.675Z" fill="currentColor" />
                <path d="M18.7182 3.90631L19.9059 5.09403L5.09397 19.906L3.90625 18.7183L18.7182 3.90631Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1693_252">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>


    );
};
